module.exports = __webpack_public_path__ + "media/Desktop_win.6e93a94f.webm";